import React, { Fragment } from 'react';
import { map, includes } from 'lodash';
import { Checkbox } from 'semantic-ui-react';

import ErrorMessage from './errorMessage';

// object of items must have fields, name and id
// optional fields, description, websiteUrl
const HHCheckboxGroup = ({ field, form: { touched, errors, setFieldValue }, items }) => {
  const hasError = !!(touched[field.name] && errors[field.name]);
  return (
    <Fragment>
      <ul>
        { map(items, (item, index) => (
          <li key={index} className={item.disabled ? 'disabled' : ''}>
            <Checkbox
              disabled={item.disabled}
              label={
                <label className='awardsField_awardName'>
                  {item.name}
                  {item.disabled && ' (Mandatory)'}
                </label>
            }
              checked={includes(field.value, item.id)}
              onChange={(e, data) => {
            // console.log(field.value);
            const result = [...field.value];
            if (data.checked) result.push(item.id);
            else {
              const idx = result.indexOf(item.id);
              result.splice(idx, 1);
            }
            setFieldValue(field.name, result);
          }}
            />
            {item.description && (
              <p className='awardsField_awardDescription'>
                {item.description}
              </p>
          )}
            {item.websiteUrl && (
              <a
                href={item.websiteUrl}
                target='_blank'
                className='awardsField_awardUrl'
                onClick={e => e.stopPropagation()}
              >
                {item.websiteUrl}
              </a>
          )}
          </li>
        )) }
      </ul>
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default HHCheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhCheckboxGroup.js